import { render } from "./SignupPage.vue?vue&type=template&id=3f33f91e&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=ts"
export * from "./SignupPage.vue?vue&type=script&lang=ts"

import "./SignupPage.vue?vue&type=style&index=0&id=3f33f91e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f33f91e"

export default script